/**
 * The stable, type-agnostic key a campaign is addressed by across every stream
 * and store slice. Prefer the human-set `custom_id`, fall back to the numeric id.
 * Uses `||` (not `??`) so an empty-string `custom_id` also falls back.
 */
export type CampaignKey = string;

export function campaignKey(campaign: {
  id: number;
  custom_id?: string;
}): CampaignKey {
  return campaign.custom_id || String(campaign.id);
}

/**
 * Whether `campaign` is the one addressed by `key`. Matches its `custom_id` OR
 * its numeric id (as string), so a lookup succeeds with either identifier — the
 * "match by custom_id or String(id)" logic used across the store selectors.
 *
 * An empty `key` never matches: `campaignKey` never *produces* `""` (it falls
 * back to the id), so a blank key means "nothing selected" — without this guard a
 * campaign with an empty-string `custom_id` would spuriously match it.
 */
export function matchesKey(
  campaign: { id: number; custom_id?: string },
  key: CampaignKey
): boolean {
  if (!key) return false;
  return campaign.custom_id === key || String(campaign.id) === key;
}
